
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { readUserProfile } from '@/store/main/getters';
import { dispatchUpdateUserProfile } from '@/store/main/actions';

@Component
export default class InactivityTimeoutSetting extends Vue {
  get minutes() {
    return readUserProfile(store)?.setting_lock_inactive_minutes ?? 0;
  }

  set minutes(val: number) {
    const profile = readUserProfile(store);
    if (profile) profile.setting_lock_inactive_minutes = val;
  }

  public async save() {
    await dispatchUpdateUserProfile(store, { setting_lock_inactive_minutes: this.minutes });
  }
}
